/* eslint-disable array-callback-return */
import { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useTranslation } from "react-i18next";
import moment from "../../helper/moment";
import { loadImage } from "../../api/documents";
import Spinner from "../Spinner";
import Modal from "../ModalUI";
import Icon from "../Icon";
import ShowObservations from "../../pages/MyPatietns/modal/showObservations";
import AddObservation from "../SharedPatientDetails/modal/addObservation";

const ShareFolderModal = ({ user, sharedFolderDetails }) => {
  const { t } = useTranslation() as any;
  const [typeObservation, setTypeObservation] = useState({
    typeObservation: "",
    idObservation: "",
  });
  const [observationModal, setObservationModal] = useState(false);
  const [showObservationsModal, setShowObservationsModal] = useState(false);
  const [selectedObservationId, setSelectedObservationId] = useState("");
  const [typeOfAddObservation, setTypeOfAddObservation] = useState("");

  const [loading] = useState<boolean>(false);
  const [antecedentsList, setAntecedentsList] = useState([]) as any;
  const [antecedentsChrirugicalList, setAntecedentsChrirugicalList] = useState(
    [] as any
  );
  const [reports, setReports] = useState<any>([]);
  const [prescriptions, setPrescriptions] = useState<any>([]);
  const [images, setImages] = useState<any>();
  const [previewReportModal, setPreviewReportModal] = useState({
    status: false,
    rapport: "",
  });

  const [treatementEnCours, setTreatementEnCours] = useState([]) as any;
  const [treatementsAncien, setTreatementsAncien] = useState([]) as any;

  // useEffect(() => {
  //   async function _getPatientById() {
  //     setLoading(true);
  //     const response = await getPatientById(user._id);
  //     setLoading(false);
  //   }
  //   _getPatientById();
  // }, []);

  const parseImage = (filename, userId, type) => ({
    original: loadImage(userId, type, "thumbnail", filename),
  });

  useEffect(() => {
    sharedFolderDetails?.prescriptions &&
      sharedFolderDetails?.prescriptions.length > 0 &&
      setPrescriptions(sharedFolderDetails.prescriptions);

    sharedFolderDetails?.reports &&
      sharedFolderDetails?.reports.length > 0 &&
      setReports(sharedFolderDetails.reports);

    sharedFolderDetails?.images &&
      sharedFolderDetails?.images.length > 0 &&
      setImages(sharedFolderDetails.images);

    sharedFolderDetails?.antecedents &&
      sharedFolderDetails?.antecedents.length > 0 &&
      setAntecedentsList(sharedFolderDetails?.antecedents);

    sharedFolderDetails?.antecedentsChirugical &&
      sharedFolderDetails?.antecedentsChirugical.length > 0 &&
      setAntecedentsChrirugicalList(sharedFolderDetails?.antecedentsChirugical);

    if (sharedFolderDetails?.treatements) {
      let tCours = [] as any;
      let tAncien = [] as any;
      sharedFolderDetails?.treatements.forEach((e) => {
        if (e.traitement === "Traitement en cours") {
          tCours.push(e);
        } else {
          tAncien.push(e);
        }
      });
      setTreatementEnCours(tCours);
      setTreatementsAncien(tAncien);
    }
  }, [sharedFolderDetails]);

  const [parsedImages, setParsedImages] = useState([]) as any;
  useEffect(() => {
    if (images) {
      const imgs = [] as any;
      images.map((img) => {
        imgs.push(parseImage(img.filePath, img.patientId, img.type));
      });
      setParsedImages(imgs);
    }
  }, [images]);
  return loading ? (
    <Spinner />
  ) : (
    <>
      <Modal
        showModal={previewReportModal?.status}
        closeModal={() =>
          setPreviewReportModal({
            status: false,
            rapport: "",
          })
        }
      >
        <div className="p-5">
          <p>{ReactHtmlParser(ReactHtmlParser(previewReportModal?.rapport))}</p>
        </div>
      </Modal>
      <div className="shared-folder  w-full h-full m-2 flex flex-col pr-3">
        <div className="flex flex-col justify-end h-full m-3 space-y-3">
          <div className="h-full">
            {images && images.length > 0 && (
              <div className="mt-10">
                <div className="flex justify-between">
                  <h3>{t("Chat.IMAGES")}</h3>
                </div>
                <div className="flexCenter flex-wrap gap-4 mt-7">
                  {parsedImages?.map((el) => {
                    // if (el.metadata && el.metadata.slice(0, 5) === "image") {
                    return (
                      <div className="relative">
                        <img
                          crossOrigin="anonymous"
                          referrerPolicy="origin"
                          src={
                            el.original
                            // process.env.REACT_APP_KATOMI_API_URL + el.filePath
                          }
                          alt="patient-folder"
                          className="rounded-lg"
                          style={{
                            width: "120px",
                            height: "120px",
                          }}
                        />
                      </div>
                    );
                    // }
                  })}
                </div>
              </div>
            )}
            {/* COMPTE RENDU */}
            {reports?.length > 0 && (
              <div className="mt-10">
                <div className="flex justify-between">
                  <h3 className="uppercase">{t("Chat.REPORT")}</h3>
                </div>
                <div className="flex flex-wrap justify-between mt-7">
                  {reports.map((el) => (
                    <div
                      className="relative report-card shadow-md"
                      onClick={() => {
                        setPreviewReportModal({ status: true, ...el });
                      }}
                    >
                      <span className="card-title block">
                        {t("Chat.ReportAt")}
                      </span>
                      <span className="block font-normal">
                        {moment(el.dateConsultation).format("DD MMMM YYYY")}
                      </span>
                      <span className="block updated-report">
                        {t("Chat.UpdatedAt")}{" "}
                        {moment(el.updatedAt).format(t("Moment.Z"))}
                      </span>
                      <div className="box max-w-max ">{el.motif}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* PRESCRIPTION */}
            {prescriptions?.length > 0 && (
              <div className="mt-10">
                <div className="flex justify-between">
                  <h3 className="uppercase"> {t("Chat.PRESCRIPTION")}</h3>
                </div>
                <div className="flex flex-wrap justify-between mt-7">
                  {prescriptions.map((el) => (
                    <div className="relative report-card shadow-md my-3">
                      <span className="card-title block">
                        {t("Chat.ReportAt")}
                      </span>
                      <span className="block font-normal">
                        {moment(el.dateConsultation).format("DD MMMM YYYY")}
                      </span>
                      <span className="block updated-report">
                        {t("Chat.UpdatedAt")}{" "}
                        {moment(el.updatedAt).format(t("Moment.Z"))}
                      </span>
                      <div className="box max-w-max ">{el.motif}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ANTECEDENT MEDICAUX */}
            {antecedentsList?.length > 0 && (
              <>
                <h3 className="mb-5"> {t("Chat.MEDICALANTECEDENTS")}</h3>
                <div className="flex flex-wrap gap-5">
                  {antecedentsList.map((med) => (
                    <div className="card-antecedent my-3">
                      <div className="flex justify-between">
                        <div>
                          <p className="card-title">{med.nature}</p>
                          <span className="block">{med.type}</span>
                        </div>
                      </div>
                      <p className="subTitle">{med.subTitle}</p>
                      <p className="card-subtitle">
                        {t("Chat.UpdatedAt")}{" "}
                        <span className="font-bold">
                          {moment(med.date).format(t("Moment.Z"))}
                        </span>
                      </p>
                      <div className="flex gap-2 my-2">
                        {med["traitements"] &&
                          med["traitements"].map((medic) => (
                            <div className="box max-w-max flex items-center space-x-2">
                              <Icon
                                name="capsule"
                                isIcon={false}
                                width={14}
                                height={16}
                              />
                              <p>{medic.traitement}</p>
                            </div>
                          ))}
                      </div>
                      {med.to ? (
                        <p
                          className="addObservation menu flexCenter"
                          onClick={() => {
                            setSelectedObservationId(med._id);
                            setObservationModal(true);
                            setTypeOfAddObservation("antecedents");
                          }}
                        >
                          {t("Chat.AddObservation")}
                        </p>
                      ) : (
                        <div className="flexCenter">
                          <div
                            className="menu addObservation cursor-pointer blue-text"
                            onClick={() => {
                              setTypeObservation({
                                typeObservation: "antecedents",
                                idObservation: med._id,
                              });
                              setShowObservationsModal(true);
                            }}
                          >
                            {med.observationsDoctor.length}{" "}
                            {t("Chat.Observations")}
                          </div>
                          <div
                            className="menu ml-6 addObservation cursor-pointer blue-text"
                            onClick={() => {
                              setSelectedObservationId(med._id);
                              setObservationModal(true);
                              setTypeOfAddObservation("antecedents");
                            }}
                          >
                            {t("Chat.Add")}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* ANTECEDENT CHIRURGICAUX */}
            {antecedentsChrirugicalList?.length > 0 && (
              <>
                <h3 className="mb-5 uppercase">
                  {" "}
                  {t("Chat.SURGICALANTECEDENTS")}
                </h3>

                <div className="flex flex-wrap gap-5 mt-3">
                  {antecedentsChrirugicalList.map((med) => (
                    <div className="card-antecedent my-3">
                      <div className="flex justify-between">
                        <div>
                          <p className="card-title">{med.nature}</p>
                          <span className="block">{med.type}</span>
                        </div>

                        {/* <Icon name="troisPoints" isIcon={true} /> */}
                      </div>
                      <p className="subTitle">{med.subTitle}</p>
                      <p className="card-subtitle">
                        {t("Chat.UpdatedAt")}{" "}
                        <span className="font-bold">
                          {moment(med.date).format(t("Moment.Z"))}
                        </span>
                      </p>
                      {med.to ? (
                        <p className="addObservation menu flexCenter blue-text">
                          {t("Chat.AddObservation")}
                        </p>
                      ) : (
                        <div className="flexCenter">
                          <div
                            className="menu addObservation cursor-pointer blue-text"
                            onClick={() => {
                              setTypeObservation({
                                typeObservation: "antecedentChirurgicaux",
                                idObservation: med._id,
                              });
                              setShowObservationsModal(true);
                            }}
                          >
                            {med.observationsDoctor.length}{" "}
                            {t("Chat.Observations")}
                          </div>
                          <div
                            className="menu ml-6 addObservation cursor-pointer blue-text"
                            onClick={() => {
                              setSelectedObservationId(med._id);
                              setObservationModal(true);
                              setTypeOfAddObservation("antecedentsChirugical");
                            }}
                          >
                            {t("Chat.Add")}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* TREATMENTS EN COURS */}
            {treatementEnCours?.length > 0 && (
              <>
                <h3 className="mb-5 uppercase"> {t("Chat.TREATMENTS")} </h3>
                <div className="flex flex-wrap gap-5">
                  {treatementEnCours &&
                    treatementEnCours.length > 0 &&
                    treatementEnCours.map((traitement) => (
                      <div className="card-traitement relative report-card ">
                        <div className="flex justify-between items-center">
                          <div className="flex card-title">
                            <p>{traitement.type}</p>
                          </div>
                        </div>
                        <p className="card-subtitle">
                          {t("Chat.UpdatedAt")}{" "}
                          <strong>{` ${moment(traitement.updatedAt).format(
                            "LL"
                          )} ${t("Chat.at")} ${moment(
                            traitement.updatedAt
                          ).format("HH:mm")}`}</strong>
                        </p>
                        <div className="flex">
                          {traitement["medicament"] &&
                            traitement["medicament"].map((medic) => {
                              return (
                                <div className="max-w-max flex">
                                  <Icon
                                    name="capsule"
                                    isIcon={false}
                                    width={14}
                                    height={16}
                                  />
                                  <p>{medic}</p>
                                </div>
                              );
                            })}
                        </div>
                        <p className="addObservation menu flexCenter traitementbtn blue-text">
                          {traitement.observationsDoctor.length === 0 ? (
                            <p
                              className="addObservation menu flexCenter cursor-pointer"
                              onClick={() => {
                                setSelectedObservationId(traitement._id);
                                setObservationModal(true);
                              }}
                            >
                              {t("Chat.AddObservation")}
                            </p>
                          ) : (
                            <div className="flexCenter">
                              <div
                                className="menu addObservation cursor-pointer"
                                onClick={() => {
                                  setTypeObservation({
                                    typeObservation: "treatements",
                                    idObservation: traitement._id,
                                  });
                                  setShowObservationsModal(true);
                                }}
                              >
                                {traitement.observationsDoctor.length}{" "}
                                {t("Chat.Observations")}
                              </div>
                              <div
                                className="menu ml-6 addObservation cursor-pointer"
                                onClick={() => {
                                  setSelectedObservationId(traitement._id);
                                  setObservationModal(true);
                                }}
                              >
                                {t("Chat.Add")}
                              </div>
                            </div>
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              </>
            )}

            {/* TREATMENTS EN ANCIEN */}
            {treatementsAncien?.length > 0 &&
              treatementsAncien.map((traitement) => {
                return (
                  <>
                    <h3 className="mb-5 uppercase">
                      {" "}
                      {t("Chat.ANCIENTTREATMENTS")}
                    </h3>
                    <div className="card-traitement relative report-card mt-5">
                      <div className="flex justify-between items-center">
                        <div className="flex card-title">
                          <p>{traitement.type}</p>
                        </div>
                        {/* <div>
                          <Icon name="troisPoints" isIcon={true} />
                        </div> */}
                      </div>
                      <p className="card-subtitle">
                        {t("Chat.UpdatedAt")}{" "}
                        <strong>{` ${moment(traitement.updatedAt).format(
                          "LL"
                        )} ${t("Chat.at")} ${moment(
                          traitement.updatedAt
                        ).format("HH:mm")}`}</strong>
                      </p>
                      <div className="flex">
                        {traitement["medicament"] &&
                          traitement["medicament"].map((medic) => {
                            return (
                              <div className="max-w-max flex">
                                <Icon
                                  name="capsule"
                                  isIcon={false}
                                  width={14}
                                  height={16}
                                />
                                <p>{medic}</p>
                              </div>
                            );
                          })}
                      </div>
                      <p className="addObservation menu flexCenter traitementbtn blue-text">
                        {traitement.observationsDoctor.length &&
                        traitement.observationsDoctor.length === 0 ? (
                          <p
                            className="addObservation menu flexCenter"
                            onClick={() => {
                              setSelectedObservationId(traitement._id);
                              setObservationModal(true);
                            }}
                          >
                            {t("Chat.AddObservation")}
                          </p>
                        ) : (
                          <div className="flexCenter">
                            <div
                              className="menu addObservation cursor-pointer"
                              onClick={() => {
                                setTypeObservation({
                                  typeObservation: "treatements",
                                  idObservation: traitement._id,
                                });
                                setShowObservationsModal(true);
                              }}
                            >
                              {traitement.observationsDoctor.length}{" "}
                              {t("Chat.Observations")}
                            </div>
                            <div
                              className="menu ml-6 addObservation cursor-pointer"
                              onClick={() => {
                                setSelectedObservationId(traitement._id);
                                setObservationModal(true);
                              }}
                            >
                              {t("Chat.Add")}
                            </div>
                          </div>
                        )}
                      </p>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
        {showObservationsModal && (
          <ShowObservations
            setOpenModal={setShowObservationsModal}
            selectedPatient={sharedFolderDetails.patient}
            openModal={observationModal}
            typeObservationObject={typeObservation}
            patientId={sharedFolderDetails.patient}
          />
        )}
        {observationModal && (
          <AddObservation
            setOpenModal={setObservationModal}
            selectedPatient={sharedFolderDetails.patient}
            selectedObservationId={selectedObservationId}
            openModal={observationModal}
            typeOfAddObservation={typeOfAddObservation}
            setAntecedentsList={setAntecedentsList}
            setAntecedentsChrirugicalList={setAntecedentsChrirugicalList}
            antecedentsList={antecedentsList}
            antecedentsChrirugicalList={antecedentsChrirugicalList}
            setTypeOfAddObservation={setTypeOfAddObservation}
          />
        )}
      </div>
    </>
  );
};

export default ShareFolderModal;
